import * as ActionTypes from 'state/types'
import * as InteractionsUtils from 'shared/utils/interactions'
import * as InboxUtils from 'shared/utils/inbox'
import { some, indexOf, removeItemFromArray } from 'shared/utils/array'

const initialState = {
  isRequesting: false,
  isFailure: false,
  filter: null,
  inbox: null,
  userId: null,
  isBusyTyping: [],
  collection: [],
  page: 0,
  pages: 0,
  count: 0
}

export default (state = initialState, action) => {
  switch (action.type) {

    case `${ActionTypes.INTERACTIONS_LIST_REQUEST}_START`: {
      return {
        ...state,
        isRequesting: true
      }
    }

    case `${ActionTypes.INTERACTIONS_LIST_REQUEST}_SUCCESS`: {
      if(!state.filter && !state.inbox) {
        return {
          ...state,
          isRequesting: false
        }
      }

      const {
        collection,
        page,
        pages,
        count
      } = action.response.payload

      const updatedCollection = (page > state.page)
        ? InteractionsUtils.mergeArray(state.collection, collection)
        : state.collection

      return {
        ...state,
        isRequesting: false,
        collection: updatedCollection,
        page,
        pages,
        count
      }
    }

    case `${ActionTypes.INTERACTIONS_LIST_REQUEST}_FAIL`:{
      return {
        ...state,
        isRequesting: false,
        isFailure: true
      }
    }

    case `${ActionTypes.INTERACTION_INFO_REQUEST}_SUCCESS`: {
      const newInteraction = action.response.payload

      if(!newInteraction) return state

      if(state.isUnassign) return {...state, isUnassign: false}

      return {
        ...state,
        collection: InteractionsUtils.addInteraction(state.collection, newInteraction)
      }
    }

    case ActionTypes.RECEIVE_NEW_INTERACTION: {
      if(
        state.isRequesting ||
        (!state.filter && !state.inbox) ||
        (state.filter !== 'all' && action.interaction.takeover === false) ||
        (state.inbox && !InboxUtils.isInteractionMatchedInbox(action.interaction, state.inbox)) ||
        (action.interaction.assigned && !InteractionsUtils.isInteractionMatchedAssignee(action.interaction, state.userId))
      ){
        return state
      }

      return {
        ...state,
        collection: InteractionsUtils.addInteraction(state.collection, action.interaction)
      }
    }
          

    case ActionTypes.RECEIVE_UPDATED_INTERACTION: {
      if(
        state.filter === 'assignee' &&
        !action.interaction.assigned
      ) {
        return {
          ...state,
          collection: InteractionsUtils.removeInteraction(state.collection, action.interaction.interactionId)
        }
      }
      
      if(action.interaction.archived && state.filter !== 'archived')
        return {
          ...state,
          collection: InteractionsUtils.removeInteraction(state.collection, action.interaction.interactionId)
        }

      if(
        state.isRequesting ||
        (!state.filter && !state.inbox) ||
        !action.interaction ||
        (!action.interaction.archived && state.filter === 'archived') ||
        (state.inbox && !InboxUtils.isInteractionMatchedInbox(action.interaction, state.inbox)) ||
        (!action.interaction.assigned && state.filter === 'assignee') ||
        (!action.interaction.assigned && state.filter === 'inbox') ||
        (action.interaction.assigned && !InteractionsUtils.isInteractionMatchedAssignee(action.interaction, state.userId))
      ) {
        return state
      }

      return {
        ...state,
        collection: InteractionsUtils.addInteraction(state.collection, action.interaction)
      }
    }

    case ActionTypes.RECEIVE_NOTICED_INTERACTION: {
      if(
        !state.collection?.length ||
        !action.payload.interaction
      ) {
        return state
      }

      const copiedCollection = [...state.collection]

      const index = indexOf(
        copiedCollection,
        interaction => interaction.interactionId === action.payload.interaction.interactionId
      )

      if(index > -1) {
        copiedCollection[index].isRead = action.payload.interaction.isRead
      }

      return {
        ...state,
        collection: copiedCollection
      }
    }

    case ActionTypes.RECEIVE_DELETED_INTERACTION: {
      return {
        ...state,
        collection: InteractionsUtils.removeInteraction(state.collection, action.interaction.interactionId)
      }
    }

    case `${ActionTypes.UNASSIGN_INTERACTION_REQUEST}_SUCCESS`: {
      if(state.filter === 'assignee'){
        const collection = state.collection.filter( (interaction) => action.response.payload.interactionId !== interaction.interactionId)
        return {
          ...state,
          isUnassign: true,
          collection
        }
      } else {
        return state
      }
    }

    case `${ActionTypes.ASSIGN_INTERACTION_REQUEST}_SUCCESS`:{
      if(state.filter === 'all' && action.response.payload.takeover === false){
        return state
      }

      const collection = state.collection.filter( (interaction) => action.response.payload.interactionId !== interaction.interactionId)
      return {
        ...state,
        collection
      }
    }

    case `${ActionTypes.ARCHIVE_INTERACTION_REQUEST}_SUCCESS`:
    case `${ActionTypes.DELETE_INTERACTION_REQUEST}_SUCCESS`:
    case `${ActionTypes.UNARCHIVE_INTERACTION_REQUEST}_SUCCESS`:{
      const collection = state.collection.filter( (interaction) => action.response.payload.interactionId !== interaction.interactionId)
      return {
        ...state,
        collection
      }
    }

    case ActionTypes.SELECT_FILTER: {
      return {
        ...state,
        collection: [],
        filter: action.payload.filter,
        inbox: null,
        page: 0,
        pages: 0,
        count: 0
      }
    }

    case ActionTypes.SELECT_INBOX: {
      return {
        ...state,
        collection: [],
        inbox: action.payload.inbox,
        filter: null,
        page: 0,
        pages: 0,
        count: 0
      }
    }

    case `${ActionTypes.PROFILE_REQUEST}_SUCCESS`: {
      const {
        profile
      } = action.response.payload

      return {
        ...state,
        userId: profile.userId
      }
    }
    
    case ActionTypes.RECEIVE_ACTIVITY_START: {
      
      const threadId = action?.payload?.threadId
      const originator = action?.payload.originator

      if(!threadId) return  {...state}
      if (some(state.isBusyTyping, (item) => item.threadId === threadId && item.originator.role === originator.role)) return  {...state}
        
      return {
        ...state,
        isBusyTyping: [
          ...state.isBusyTyping,
          {
            threadId,
            originator
          }
          
        ]
      }
    }

    case ActionTypes.RECEIVE_ACTIVITY:
    case ActionTypes.REMOVE_BUSY_TYPING: {
      const threadId = action?.payload?.threadId || action?.activity?.threadId
      const originator = action?.payload?.originator
      let activityIndex = -1

      if(!originator) activityIndex = indexOf(state.isBusyTyping, (item)=> item.threadId === threadId && item.originator.role !== 'bot' )
      else activityIndex = indexOf(state.isBusyTyping, (item)=> item.threadId === threadId && item.originator.role === originator.role )

      if(!threadId || activityIndex === -1) return  {...state}

      const newColl = removeItemFromArray(state.isBusyTyping, activityIndex)

      return {
        ...state,
        isBusyTyping: newColl
      }
    }



    default:
      return state
  }
}
